module.exports = __webpack_public_path__ + "img/tutorial-f05-06.5445c533.png";